let csrfToken = ''

export function setCsrfToken(value: string): void {
  csrfToken = value
}

export class ApiError extends Error {
  status: number
  constructor(message: string, status: number) {
    super(message)
    this.status = status
  }
}

export async function api<T>(path: string, init: RequestInit = {}): Promise<T> {
  const headers = new Headers(init.headers)
  if (init.body && !(init.body instanceof FormData)) headers.set('content-type', 'application/json')
  if (csrfToken && !['GET', 'HEAD'].includes((init.method ?? 'GET').toUpperCase())) headers.set('x-csrf-token', csrfToken)
  const response = await fetch(path, { ...init, headers, credentials: 'same-origin' })
  const payload = await response.json().catch(() => ({ error: 'Resposta inválida do servidor' })) as { error?: string } | T
  if (!response.ok) throw new ApiError('error' in (payload as object) ? (payload as { error?: string }).error ?? 'Não foi possível concluir' : 'Não foi possível concluir', response.status)
  return payload as T
}

export async function apiFile(path: string, init: RequestInit = {}): Promise<{ blob: Blob; filename: string }> {
  const headers = new Headers(init.headers)
  if (init.body && !(init.body instanceof FormData)) headers.set('content-type', 'application/json')
  if (csrfToken && !['GET', 'HEAD'].includes((init.method ?? 'GET').toUpperCase())) headers.set('x-csrf-token', csrfToken)
  const response = await fetch(path, { ...init, headers, credentials: 'same-origin' })
  if (!response.ok) {
    const payload = await response.json().catch(() => ({ error: 'Não foi possível gerar o arquivo' })) as { error?: string }
    throw new ApiError(payload.error ?? 'Não foi possível gerar o arquivo', response.status)
  }
  const disposition = response.headers.get('content-disposition') ?? ''
  const encodedName = disposition.match(/filename\*=UTF-8''([^;]+)/i)?.[1]
  const plainName = disposition.match(/filename="?([^";]+)"?/i)?.[1]
  const filename = encodedName ? decodeURIComponent(encodedName) : plainName ?? 'pedidos.csv'
  return { blob: await response.blob(), filename }
}

export async function login(email: string, password: string): Promise<void> {
  const result = await api<{ csrfToken: string }>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ email, password }),
  })
  setCsrfToken(result.csrfToken)
}
